import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <React.Fragment>
    <path d="M18.4254826,8.47279157 C18.7166518,8.1781844 19.1915174,8.17539735 19.4861245,8.46656653 C19.7539492,8.73126578 19.7806003,9.14778022 19.5644728,9.44266525 L19.4923496,9.52720843 L13.057,16.037 L19.4892462,22.4696699 C19.7555128,22.7359365 19.7797188,23.1526002 19.5618643,23.4462117 L19.4892462,23.5303301 C19.2229796,23.7965966 18.8063159,23.8208027 18.5127045,23.6029482 L18.428586,23.5303301 L11.4696699,16.571414 C11.2045077,16.3062518 11.1792562,15.8916711 11.3947088,15.5980595 L11.4665665,15.5138755 L18.4254826,8.47279157 Z" />
  </React.Fragment>,
  'ArrowLeft'
);
